// Campos do link público, na ordem do formulário. A configuração grava `${campo}Visivel` (nulo exibe)
// e `${campo}Obrigatorio`; nulo segue obrigatório, exceto nos campos criados depois da configuração
// (CAMPOS_OPCIONAIS_POR_PADRAO).
export const GRUPOS_CAMPOS_PREENCHIMENTO = [
  {
    titulo: "Identificacao",
    campos: [
      { campo: "nomeSocial", label: "Nome_social" },
      { campo: "cpf", label: "CPF" },
      { campo: "email", label: "Email" },
      { campo: "telefone", label: "Telefone" },
      { campo: "dtNascimento", label: "Data_de_nascimento" },
      { campo: "sexo", label: "Sexo" },
      { campo: "naturalidade", label: "Naturalidade" },
      { campo: "instrucao", label: "Instrucao" },
      { campo: "raca", label: "Raca" },
      { campo: "estadoCivil", label: "Estado_civil" },
      { campo: "grupoSanguineo", label: "Grupo_sanguineo" },
    ],
  },
  {
    titulo: "Endereco",
    campos: [
      { campo: "cep", label: "Cep" },
      { campo: "logradouro", label: "Logradouro" },
      { campo: "numero", label: "Numero" },
      { campo: "complemento", label: "Complemento" },
      { campo: "bairro", label: "Bairro" },
      { campo: "uf", label: "UF" },
      { campo: "cidade", label: "Cidade" },
    ],
  },
  {
    titulo: "Documentos",
    campos: [
      { campo: "pis", label: "PIS" },
      { campo: "rg", label: "RG" },
      { campo: "rgExpedicao", label: "Expedicao_rg" },
      { campo: "rgUF", label: "Uf_expedicao_rg" },
      { campo: "cnh", label: "CNH" },
      { campo: "cnhCategoria", label: "Categoria_cnh" },
      { campo: "cnhUF", label: "Uf_cnh" },
      { campo: "cnhValidade", label: "Cnh_validade" },
      { campo: "cnhEmissao", label: "Cnh_emissao" },
      { campo: "ctpsNumero", label: "Numero_ctps" },
      { campo: "ctpsSerie", label: "Serie_ctps" },
      { campo: "ctpsUF", label: "Ctps_uf" },
      { campo: "reservistaCategoria", label: "Categoria_reservista" },
      { campo: "reservistaNumero", label: "Numero_reservista" },
      { campo: "tituloEleitoral", label: "tituloEleitoral" },
      { campo: "tituloEleitoralZona", label: "tituloEleitoralZona" },
      { campo: "tituloEleitoralSecao", label: "tituloEleitoralSecao" },
    ],
  },
  {
    titulo: "Dados_familiares",
    campos: [
      { campo: "nomePai", label: "Nome_do_pai" },
      { campo: "nomeMae", label: "Nome_da_mae" },
      { campo: "nomeConjuge", label: "Nome_conjuge" },
    ],
  },
  {
    titulo: "Dados_bancarios",
    campos: [
      { campo: "contaBanco", label: "Banco" },
      { campo: "contaAgencia", label: "Agencia_numero" },
      { campo: "contaNumero", label: "Conta_numero" },
      { campo: "contaOperacao", label: "Conta_operacao" },
      { campo: "chavePix", label: "ChavePix" },
    ],
  },
  {
    titulo: "Vencimentos",
    campos: [
      {
        campo: "vencimentoSeguancaPessoal",
        label: "vencimento_seguanca_pessoal",
      },
      {
        campo: "vencimentoSegurancaPatrimonial",
        label: "vencimento_seguranca_patrimonial",
      },
      {
        campo: "vencimentoSegurancaTransporteValores",
        label: "vencimento_seguranca_transporte_valores",
      },
      {
        campo: "vencimentoPscicotecnico",
        label: "vencimento_pscicotecnico",
      },
      { campo: "vencimentoToxicologico", label: "vencimento_toxicologico" },
    ],
  },
];

export const CAMPOS_PREENCHIMENTO = GRUPOS_CAMPOS_PREENCHIMENTO.flatMap(
  (grupo) => grupo.campos
);

export function chaveConfiguracao(campo) {
  return `${campo}Obrigatorio`;
}

export function chaveVisibilidade(campo) {
  return `${campo}Visivel`;
}

export function campoVisivelNoLink(configuracao, campo) {
  const valor = configuracao
    ? configuracao[chaveVisibilidade(campo)]
    : undefined;
  return valor !== false;
}

// Sem escolha gravada ficam opcionais, para não passar a exigi-los de quem já configurou o link
const CAMPOS_OPCIONAIS_POR_PADRAO = ["chavePix", "telefone"];

// Campo oculto no link nunca é exigido do candidato.
export function campoObrigatorioNoLink(configuracao, campo) {
  if (!campoVisivelNoLink(configuracao, campo)) {
    return false;
  }
  const valor = configuracao ? configuracao[chaveConfiguracao(campo)] : undefined;
  if (valor === undefined || valor === null) {
    return !CAMPOS_OPCIONAIS_POR_PADRAO.includes(campo);
  }
  return valor !== false;
}

// Exigidos no cadastro do funcionário (tela e API); a aprovação pede que o aprovador os complete.
export const CAMPOS_OBRIGATORIOS_APROVACAO = [
  { campo: "nomeSocial", label: "Nome_social" },
  { campo: "cpf", label: "CPF" },
  { campo: "email", label: "Email" },
  { campo: "dtNascimento", label: "Data_de_nascimento" },
  { campo: "sexo", label: "Sexo" },
  { campo: "naturalidade", label: "Naturalidade" },
  { campo: "instrucao", label: "Instrucao" },
  { campo: "raca", label: "Raca" },
  { campo: "estadoCivil", label: "Estado_civil" },
  { campo: "nomeMae", label: "Nome_da_mae" },
  { campo: "cep", label: "Cep" },
  { campo: "logradouro", label: "Logradouro" },
  { campo: "numero", label: "Numero" },
  { campo: "bairro", label: "Bairro" },
  { campo: "cidade", label: "Cidade" },
];

export function campoVazio(valor) {
  if (valor === null || valor === undefined) {
    return true;
  }
  if (typeof valor === "string") {
    return valor.trim() === "";
  }
  // Cidade e naturalidade só valem com o cadastro selecionado.
  if (typeof valor === "object" && !Array.isArray(valor)) {
    return valor.id === null || valor.id === undefined;
  }
  return false;
}

// Situação dos campos obrigatórios do link, na ordem do formulário.
export function situacaoCamposNoLink(configuracao, recurso = {}) {
  return GRUPOS_CAMPOS_PREENCHIMENTO.flatMap((grupo) =>
    grupo.campos
      .filter(({ campo }) => campoObrigatorioNoLink(configuracao, campo))
      .map((item) => ({
        ...item,
        grupo: grupo.titulo,
        pendente: campoVazio(recurso[item.campo]),
      }))
  );
}

// Dados pessoais enviados pelo link público e pela aprovação.
export function dadosPessoais(recurso = {}) {
  return {
    nomeSocial: recurso.nomeSocial,
    cpf: recurso.cpf,
    email: recurso.email,
    telefone: recurso.telefone,
    sexo: recurso.sexo,
    dtNascimento: recurso.dtNascimento,
    naturalidade: recurso.naturalidade,
    grupoSanguineo: recurso.grupoSanguineo,
    instrucao: recurso.instrucao,
    nivelSuperior: recurso.nivelSuperior,
    raca: recurso.raca,
    estadoCivil: recurso.estadoCivil,
    logradouro: recurso.logradouro,
    numero: recurso.numero,
    complemento: recurso.complemento,
    bairro: recurso.bairro,
    cep: recurso.cep,
    cidade: recurso.cidade,
    uf: recurso.uf,
    pis: recurso.pis,
    rg: recurso.rg,
    rgExpedicao: recurso.rgExpedicao,
    rgUF: recurso.rgUF,
    cnh: recurso.cnh,
    cnhEmissao: recurso.cnhEmissao,
    cnhUF: recurso.cnhUF,
    cnhValidade: recurso.cnhValidade,
    cnhCategoria: recurso.cnhCategoria,
    ctpsNumero: recurso.ctpsNumero,
    ctpsSerie: recurso.ctpsSerie,
    ctpsUF: recurso.ctpsUF,
    reservistaNumero: recurso.reservistaNumero,
    reservistaCategoria: recurso.reservistaCategoria,
    tituloEleitoral: recurso.tituloEleitoral,
    tituloEleitoralZona: recurso.tituloEleitoralZona,
    tituloEleitoralSecao: recurso.tituloEleitoralSecao,
    nomePai: recurso.nomePai,
    nomeMae: recurso.nomeMae,
    nomeConjuge: recurso.nomeConjuge,
    primeiroEmprego: recurso.primeiroEmprego,
    defFisica: recurso.defFisica,
    defVisual: recurso.defVisual,
    defAuditiva: recurso.defAuditiva,
    defMental: recurso.defMental,
    defIntelectual: recurso.defIntelectual,
    cotaDeficiencia: recurso.cotaDeficiencia,
    opcaoFGTS: recurso.opcaoFGTS,
    inssOptante: recurso.inssOptante,
    contaBanco: recurso.contaBanco,
    contaAgencia: recurso.contaAgencia,
    contaNumero: recurso.contaNumero,
    contaOperacao: recurso.contaOperacao,
    chavePix: recurso.chavePix,
    vencimentoSeguancaPessoal: recurso.vencimentoSeguancaPessoal,
    vencimentoSegurancaPatrimonial: recurso.vencimentoSegurancaPatrimonial,
    vencimentoSegurancaTransporteValores:
      recurso.vencimentoSegurancaTransporteValores,
    vencimentoPscicotecnico: recurso.vencimentoPscicotecnico,
    vencimentoToxicologico: recurso.vencimentoToxicologico,
    alertaApuracaoPonto: recurso.alertaApuracaoPonto,
    dependentes: recurso.dependentes,
  };
}
